import { makeStyles } from '@material-ui/core';
import React from 'react';
import { InputSearchField } from 'components/DynamicScreen/CardWidgets/FormWidgets';

const useStyles = makeStyles((theme) => ({
  dropdown: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
}));

const SearchFieldCell = React.memo(
  ({
    row,
    column,
    rowState,
    handleRowChange,
    handleDeeplink,
    pseudoFormState,
    ...props
  }) => {
    const saveAction = (deeplink, apiType, val) => {
      const body = { ...pseudoFormState };
      (body.rows || []).find((ele) => ele.id === row.id)[column.key] = val;
      handleDeeplink(deeplink, apiType, body);
    };
    return (
      <InputSearchField
        selected={(row[column.key] || {}).value}
        handleSelectOption={(id) =>
          handleRowChange(row.id, { [column.key]: id })
        }
        deeplink={column.deep_link}
        apiType={column.apiType}
        saveDeeplink={column.saveDeeplink}
        hint={column.hint}
        tableCell={true}
        handleDeeplink={handleDeeplink}
        disableCustomInput={true}
        saveAction={saveAction}
        emptyResults={column.emptyResults}
        pseudoFormState={pseudoFormState}
        handleDeepLinkFunction={props.handleDeepLinkFunction}
      />
    );
  },
  (prevProps, currentProps) =>
    (prevProps.rowState || {})[(prevProps.column || {}).key] ===
      (currentProps.rowState || {})[(currentProps.column || {}).key] &&
    prevProps.delected === currentProps.selected
);

export default SearchFieldCell;
